import { render, staticRenderFns } from "./summaryApprovalDetails.vue?vue&type=template&id=ca579300&scoped=true&"
import script from "./summaryApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./summaryApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./summaryApprovalDetails.vue?vue&type=style&index=0&id=ca579300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca579300",
  null
  
)

export default component.exports